import CostBreakdownTable from "@/components/CostBreakdownTable";
import CostDisclaimer from "@/components/CostDisclaimer";
import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

interface ConfirmationCardProps {
  podcastName: string;
  episodeCount: number;
  estimatedCostCents: number;
  creditBalanceCents: number | null;
  amountToChargeCents: number;
  onConfirm: () => void;
  onBack?: () => void;
  isProcessing?: boolean;
  className?: string;
}

export default function ConfirmationCard({
  podcastName,
  episodeCount,
  estimatedCostCents,
  creditBalanceCents,
  amountToChargeCents,
  onConfirm,
  onBack,
  isProcessing = false,
  className,
}: ConfirmationCardProps) {
  return (
    <div
      className={cn(
        "rounded-2xl px-5 py-4 space-y-4",
        theme.borders.neubrutalism,
        "bg-white/90 dark:bg-gray-900/50 text-gray-900 dark:text-white",
        theme.shadows.neubrutalismSm,
        className,
      )}
    >
      <div>
        <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Confirm Subscription</h3>
        <div className="space-y-1">
          <p className="text-base font-medium text-gray-900 dark:text-white">{podcastName}</p>
          <p className="text-sm text-gray-600 dark:text-gray-400">{episodeCount} episodes</p>
        </div>
      </div>

      <CostBreakdownTable
        estimatedCostCents={estimatedCostCents}
        creditBalanceCents={creditBalanceCents}
        amountToChargeCents={amountToChargeCents}
      />

      <CostDisclaimer />

      {amountToChargeCents > 0 && (
        <div className="flex items-start gap-2 text-xs text-gray-600 dark:text-gray-400">
          <span className="text-base leading-none">💳</span>
          <span>Will charge your payment method on file</span>
        </div>
      )}

      <div className="flex flex-col gap-3 sm:flex-row-reverse">
        <button
          type="button"
          onClick={onConfirm}
          disabled={isProcessing}
          className={cn(
            "flex-1 inline-flex items-center justify-center rounded-full px-8 py-3 text-base font-semibold min-h-[3.25rem]",
            theme.buttons.primary,
            "disabled:opacity-60 disabled:cursor-not-allowed",
          )}
        >
          {isProcessing
            ? "Processing..."
            : amountToChargeCents > 0
              ? "Pay and Add Podcast Now"
              : "Add Podcast Now"}
        </button>
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            disabled={isProcessing}
            className={cn(
              "inline-flex items-center justify-center rounded-full px-6 py-3 text-base font-semibold min-h-[3.25rem]",
              theme.buttons.secondary,
              "disabled:opacity-60 disabled:cursor-not-allowed",
            )}
          >
            Change choice
          </button>
        )}
      </div>
    </div>
  );
}
